
import i18n from '@/i18n';export const TAG_COLOR_INFO = [
  { name: i18n.t('蓝色'), color: '#0066FF', backgroundColor: '#F0F6FF', borderColor: '#C2DAFF' },
  { name: i18n.t('天蓝'), color: '#28A2FA', backgroundColor: '#EBF6FF', borderColor: '#CCEAFF' },
  { name: i18n.t('青色'), color: '#2BDEEA', backgroundColor: '#EBFEFF', borderColor: '#CCFCFF' },
  { name: i18n.t('绿色'), color: '#00C788', backgroundColor: '#E6FAF4', borderColor: '#C9F0E3' },
  { name: i18n.t('黄色'), color: '#FAC228', backgroundColor: '#FFF8E5', borderColor: '#FFECB8' },
  { name: i18n.t('橙色'), color: '#F57E22', backgroundColor: '#FFF3EB', borderColor: '#FFDFC7' },
  { name: i18n.t('红色'), color: '#DB3543', backgroundColor: '#FFEBEC', borderColor: '#FFD6D9' },
  { name: i18n.t('紫色'), color: '#A910E5', backgroundColor: '#F9EBFF', borderColor: '#F0C9FF' },
  { name: i18n.t('暗紫'), color: '#5410E5', backgroundColor: '#F2ECFF', borderColor: '#D8C6FF' },
  { name: i18n.t('中蓝'), color: '#333AFF', backgroundColor: '#F0F0FF', borderColor: '#D6D8FF' },
];
